import { settleApiCall } from '../../../api/utils';
import { createFieldToEntityMap } from '../../../utils/common';
export const getLabels = async _ref => {
  let {
    labelsClient,
    items,
    populationLevel
  } = _ref;
  const shouldPopulateLabels = populationLevel == null ? void 0 : populationLevel.labels;
  if (!shouldPopulateLabels) {
    return {
      data: [],
      hasError: false
    };
  }
  const someItemsHaveLabels = items.some(item => (item.labels || []).length > 0);
  if (someItemsHaveLabels) {
    const labelsApiResponse = await settleApiCall(() => labelsClient.getBulk());
    if (labelsApiResponse.hasError) {
      return labelsApiResponse;
    }
    const labelsMap = createFieldToEntityMap(labelsApiResponse.data.data, 'id');
    return {
      data: labelsApiResponse.data.data,
      idsToEntityMap: labelsMap,
      hasError: false
    };
  }
  return {
    data: [],
    hasError: false
  };
};
//# sourceMappingURL=getLabels.js.map